import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge can't tell our token font sizes (`text-h1`, `text-display-lg`, …) from text colors, so by default
 * `cn('text-display-lg', 'text-status-ontime')` would drop the size. Register the design-token type scale.
 */
const FONT_SIZES = ['display-xl', 'display-lg', 'display', 'title', 'h1', 'h2', 'h3', 'body-lg', 'body', 'caption', 'micro'];
const twMerge = extendTailwindMerge({ extend: { theme: { text: FONT_SIZES } } });

/** Merge Tailwind classes safely. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
